var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "3"
              }
            },
            [
              _c(
                "gg-card",
                {
                  staticClass: "fill-height"
                },
                [
                  _c("gg-card-header", [_vm._v(" Select Period ")]),
                  _c(
                    "gg-card-text",
                    [
                      _vm._v(" Select a period for the report view. "),
                      _c(
                        "v-menu",
                        {
                          ref: "menu",
                          attrs: {
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "290px",
                            "min-width": "auto"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function fn(_ref) {
                                var on = _ref.on,
                                  attrs = _ref.attrs
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c("gg-input-label", [
                                        _vm._v("Reporting Period")
                                      ]),
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                dense: "",
                                                outlined: "",
                                                autocomplete: "off",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                value: _vm.formattedDate
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.menu,
                            callback: function callback($$v) {
                              _vm.menu = $$v
                            },
                            expression: "menu"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              type: "month",
                              "no-title": "",
                              scrollable: "",
                              min: "2009-01",
                              max: _vm.currentDate
                            },
                            on: {
                              change: _vm.getData
                            },
                            model: {
                              value: _vm.date,
                              callback: function callback($$v) {
                                _vm.date = $$v
                              },
                              expression: "date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c("gg-card-header", [_vm._v(" Traffic Detail ")]),
                  _c(
                    "gg-card-text",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.trafficDetails,
                          loading: _vm.pending
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.browser",
                            fn: function fn(_ref2) {
                              var item = _ref2.item
                              return [
                                _c("code", [_vm._v(_vm._s(item.browser))])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }